import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils.ts";

export function Spinner({ className, size = 16, ...props }: React.ComponentProps<"span"> & { size?: number }) {
  return (
    <span role="status" aria-live="polite" aria-label="Loading" data-slot="spinner" className={cn("inline-flex shrink-0 items-center justify-center text-current", className)} {...props}>
      <Loader2 className="animate-spin" style={{ width: size, height: size }} aria-hidden="true" />
    </span>
  );
}
